import { IBettingOption, IDropdownConfig } from '../model/betting.model';
import { UtilsService } from '../../../../../../../../services/utils.service';
import { GoalsDiff, ITeamLookupDto, MatchDuration, UnderOver } from '@oogaday/shared';

export class OptionsProviderService {
  static getBestGoalScorerOptions(teams: ITeamLookupDto[]): IDropdownConfig[] {
    const players: IBettingOption[] = teams
      .flatMap((team) => team.players)
      .map((player) => ({
        value: player.id,
        name: player.name,
      }));

    return [
      {
        label: 'Best Goalscorer',
        options: players,
      },
    ];
  }

  static getRangeOptions(to = 30): IDropdownConfig[] {
    const range = UtilsService.genRangeOptions(to);

    return [
      {
        label: 'Select an option',
        options: range,
      },
    ];
  }

  static getMatchDurationOptions(): IDropdownConfig<MatchDuration>[] {
    return [
      {
        label: 'Select an option',
        options: [
          {
            value: '90',
            name: '90 minutes',
          },
          {
            value: '120',
            name: '120 minutes',
          },
          {
            value: 'penalties',
            name: 'Penalties',
          },
        ],
      },
    ];
  }

  static getGoalDiffOptions(teamAName: string, teamBName: string, short: boolean = false): IDropdownConfig[] {
    const values: GoalsDiff[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const options = values.map((value) => {
      let name: string;

      if (value < 5) {
        if (short) {
          name = value === 1 ? ' +4' : ` +${5 - value}`;
        } else {
          name = teamAName + (value === 1 ? ' +4 or More' : ` +${5 - value}`);
        }
      } else if (value === 5) {
        name = short ? '0' : 'Tie (No diff)';
      } else {
        if (short) {
          name = value === 9 ? ' +4' : ` +${value - 5}`;
        } else {
          name = teamBName + (value === 9 ? ' +4 or More' : ` +${value - 5}`);
        }
      }

      return {
        value,
        name,
      };
    });

    return [
      {
        label: 'Goals Difference',
        options,
      },
    ];
  }

  static fastestGoalOptions(): IDropdownConfig[] {
    const range = UtilsService.genRangeOptions(10);

    return [
      {
        label: 'Fastest goal',
        options: [
          ...range,
          {
            value: 'more_than',
            name: 'More than 10',
          },
        ],
      },
    ];
  }

  static getTeamsOptions(label: string, teams: ITeamLookupDto[]): IDropdownConfig[] {
    return [
      {
        label,
        options: teams.map((team) => ({
          value: team.id,
          name: team.name,
        })),
      },
    ];
  }

  static getUnderOverOptions(pivot: number): IBettingOption<UnderOver>[] {
    return [
      {
        value: 'under',
        name: `Under ${pivot}`,
      },
      {
        value: 'over',
        name: `Over ${pivot} (including)`,
      },
    ];
  }
}
